import React from "react";

function Profile() {
  return (
    <div className="min-h-screen bg-black text-white pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold mb-8">Profile Page</h1>
        <p className="text-gray-400">This is a placeholder for the Profile page.</p>
      </div>
    </div>
  );
}

export default Profile;